import { render, staticRenderFns } from "./DateTimeRangeField.vue?vue&type=template&id=ddfab4f2&scoped=true"
import script from "./DateTimeRangeField.vue?vue&type=script&lang=js"
export * from "./DateTimeRangeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfab4f2",
  null
  
)

export default component.exports